/** @format */

import {ChangeEvent, useState} from 'react';

import {Box, LinearProgress, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import SidebarNew from 'components/MediaplanSidebar/SidebarNew';

import {useCompanyContext} from 'contexts/CompanyContext';
import {useMixpanelContext} from 'contexts/MixpanelContext';

import {isLimitReachedError} from 'helpers/apolloErrorHelpers';

import NameStep from '../../NameStep';
import {useCreateCompanyMutation} from './graphql/__generated__';

const Create = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const {mixpanel} = useMixpanelContext();
  const {switchCompany} = useCompanyContext();

  const [projectName, setProjectName] = useState('');
  const [saveCompanyError, setSaveCompanyError] = useState('');

  const [createCompany, {loading: createCompanyLoading}] = useCreateCompanyMutation();

  if (createCompanyLoading) return <LinearProgress style={{flex: 1}} />;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setProjectName(e.target.value);
    if (saveCompanyError) setSaveCompanyError('');
  };

  const handleProjectNameConfirm = async () => {
    setSaveCompanyError('');

    try {
      mixpanel.track('click_wizard_create_company_button');

      const {data: createCompanyData} = await createCompany({
        variables: {name: projectName},
      });

      if (!createCompanyData?.createCompany.id) {
        setSaveCompanyError(t('Не удалось создать проект.'));
        return;
      }

      switchCompany(createCompanyData.createCompany);

      navigate(`/home/project/created?companyId=${createCompanyData.createCompany.id}`);
    } catch (e) {
      if (isLimitReachedError(e)) {
        setSaveCompanyError(t('Достигнут лимит проектов. Обратитесь к менеджеру'));
      } else {
        const message = e instanceof Error ? e.message : 'Unknown error.';
        setSaveCompanyError(message);
      }
    }
  };

  return (
    <>
      <SidebarNew activeStep={'CREATE'} />

      <Box>
        <Typography variant='h1'>
          <Trans>Создание проекта</Trans>
        </Typography>

        <NameStep
          onChange={handleChange}
          saveCompanyError={saveCompanyError}
          onConfirm={handleProjectNameConfirm}
          projectName={projectName}
        />
      </Box>
    </>
  );
};

export default Create;
